<template>
    <Dialog v-model="dialog" @input="$listeners.input" :title="title" width="450" :show-close-button="showCloseButton">
        <v-form ref="form" @submit.prevent="confirm">
            <DynamicSelect label="Estrutura Comercial:"
                           id="EstruturaComercialSelect"
                           v-model="estrutura_comercial"
                           placeholder="Selecione a estrutura comercial"
                           endpoint="/dynamic-selects/hierarquia_comercial/estrutura"
                           :multiple="false"
                           :rules="[$rules.required]"
                           :return-object="true"
                           :params="params"
                           item-text="nomeExibicaoEstrutura"
                           :key="autoCompleteKey"
            />
            <div class="d-flex justify-center mt-4">
                <v-btn class="transition" color="primary" rounded @click="showConfirmation">
                    Confirmar
                </v-btn>
            </div>
            <v-form />
        </v-form>
    </Dialog>
</template>

<script>
  import { CommercialHierarchyTypes } from '@/plugins/constants'
  import commercialHierarchy from '@/mixins/commercialHierarchy'
  import pontosVendaMixin from '../../mixins/CommercialHierarchy/pontosVendaMixin'
  export default {
    name: 'DialogEstruturaComercial',
    mixins: [commercialHierarchy, pontosVendaMixin],
    props: {
      value: { type: Boolean, default: true },
      gerenteNegocio: String,
      estruturaDoGnSelecionado: String,
      showCloseButton: { type: Boolean, default: true },
      isEntrandoFluxoVenda: { type: Boolean, default: false }
    },
    data: () => ({
      title: 'SELECIONE A ESTRUTURA COMERCIAL',
      estrutura_comercial: null,
      autoCompleteKey: 0
    }),
    computed: {
      params () {
        if (this.gerenteNegocio) {
          return {
            gerenteNegocio: this.gerenteNegocio,
            isEntrandoFluxoVendas: this.isEntrandoFluxoVendaComputed
          }
        }
        return {
          idEstruturaComercial: this.estruturaDoGnSelecionado,
          isEntrandoFluxoVendas: this.isEntrandoFluxoVendaComputed
        }
      },
      dialog: {
        get () {
          return this.value
        },
        set (val) {
          if (!val) {
            this.isEntrandoFluxoVendaComputed = false
          }
          this.$emit('input', val)
        }
      },
      isEntrandoFluxoVendaComputed: {
        get () {
          return this.isEntrandoFluxoVenda
        },
        set (val) {
          this.$emit('setarEntrandoFluxoVenda', val)
        }
      }
    },
    watch: {
      value (newValue, oldValue) {
        if (newValue && !oldValue) {
          this.estrutura_comercial = null
          this.autoCompleteKey++
        }
      }
    },
    methods: {
      showConfirmation () {
        this.isUsuarioFluxoVendas(true, this.confirm, this.isEntrandoFluxoVendaComputed)
      },
      fecharDialog () {
        if (this.isEntrandoFluxoVendaComputed) {
          this.$emit('voltarFluxoVenda')
        } else {
          this.$router.replace({ path: '/', query: { redirecionamentoPainelLateral: true } })
        }
        this.$emit('input', false)
      },
      async confirm () {
        const form = this.$refs.form
        if (this.estrutura_comercial?.nomeExibicaoEstrutura.toString().toLowerCase() === CommercialHierarchyTypes.Todos.text.toLowerCase()) {
          this.resetarEstruturaComercial()
          this.fecharDialog()
        } else if (form.validate()) {
          this.setarEstruturaGNRC(this.estrutura_comercial)
          this.resetarPontoDeVenda()
          const pontosVenda = await this.carregarPontosVenda({
            idEstruturaSelecionada: this.estrutura_comercial.idEstruturaComercial,
            isEntrandoFluxoVendas: this.isEntrandoFluxoVendaComputed,
            gerenteNegocio: this.gerenteNegocio
          })

          this.$emit('pontosVendaCarregados', pontosVenda || [])
          this.fecharDialog()
        }
      }
    }
  }
</script>

<style scoped>

</style>
